<template>
  <div class="h-100 d-flex justify-center align-center">
    <v-sheet
      class="rounded-xl pa-5 d-flex flex-column"
      style="width: 90%;gap:10px"
    >
      <div class="d-flex flex-column align-center" style="gap:5px">
        <v-icon color="success" size="100px">mdi-check-circle-outline</v-icon>
        <h1>₹{{ pymtDetails.amount }}</h1>
        <div class="d-flex align-center">
          <!-- <v-icon color="success">mdi-check-decagram</v-icon> -->
          <h4 class="text-title ml-2">Payment Successful !</h4>
          <h2 class="text-title ml-2"></h2>
        </div>
        <label class="text-title ">{{
          (pymtDetails.trans_date)
        }}</label>
      </div>
      <v-sheet color="#f9f9f9" class="rounded-xl">
        <div class="d-flex flex-column align-start ma-5">
          <div>
            <label class="text-title">Order Id</label>
            <p class="text-info">{{pymtDetails.order_id}}</p>
          </div>
          <div>
            <label class="text-title">Transaction ID</label>
            <p class="text-info">{{ pymtDetails.tracking_id }}</p>
          </div>
          <div>
            <label class="text-title">Ref No</label>
            <p class="text-info">{{pymtDetails.bank_ref_no}}</p>
          </div>
          <div>
            <label class="text-title">Payment Mode</label>
            <p class="text-info">{{ pymtDetails.payment_mode }}</p>
          </div>
        </div>
      </v-sheet>
      <div>
        <v-btn color="primary" block @click="$router.push({name:'Home'})">Back</v-btn>
      </div>

      <!-- <div class="d-flex justify-center align-center flex-column">
        <v-sheet color="#f9f9f9" class="rounded-xl mt-2" style="width: 95%;">
        </v-sheet>
      </div> -->
    </v-sheet>
  </div>
</template>
<script>
import dayjs from "dayjs";
export default {
  props: {
    pymtDetails: {
      type: Object,
    },
  },
  methods: {
    longFormatDate(d) {
      return dayjs(d).format("MMM DD, YYYY HH:mm A");
    },
    redirectToHome(){
      this.$router.push({name:"Home"});
    }
  },
};
</script>
<style scoped>
.text-title {
  color: #8d8d93;
}
.text-info {
  font-size: 20px;
}
</style>
